export function slideshowInit() {
    const slideshow = document.querySelector('.c-slideshow');
    if (slideshow) {
        slideshow.addEventListener('mouseenter', slideShowHover);
        slideshow.addEventListener('mouseleave', slideShowHover);
    }
}

export function slideShowHover(e) {
    var eventType = e.type;
    var arrows = $(e.currentTarget).children('.slick-arrow');

    if (eventType === 'mouseenter') {
      $(arrows).addClass('active');
    } else {
      $(arrows).removeClass('active');
    }
}